<template>
	<div v-if="shouldShow" class="omapi-alert-bar-wrapper">
		<div class="omapi-alert-bar" :class="barClass">
			<template v-if="!connected">
				<strong>Important:</strong> Begin by claiming your free OptinMonster account, or connecting to your
				existing one.
				<core-wizard-button :link-style="true" :is-link="true" :arrow="true">
					<strong>Click Here to Get Started Now!</strong>
				</core-wizard-button>
			</template>
			<template v-else-if="isLiteUser">
				You're using <strong>OptinMonster Free</strong>. Click here to
				<core-upgrade-button :link-style="true" :is-link="true" :arrow="true" utm-medium="AlertBar">
					<strong>Upgrade to Pro</strong>
				</core-upgrade-button>
			</template>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	data() {
		return {
			ringing: false,
			ringTimeout: false,
			ringInterval: false,
		};
	},
	computed: {
		...mapGetters(['connected', 'isLiteUser']),
		shouldShow() {
			return !this.connected || this.isLiteUser;
		},
		barClass() {
			let classes = '';

			if (this.shouldShow) {
				classes += this.connected
					? `omapi-alert-bar__needs-upgrade${this.ringing ? ' ringing' : ''}`
					: 'omapi-alert-bar__needs-connection';
			}

			return classes;
		},
	},
	watch: {
		shouldShow(val) {
			this.toggleRing(val);
		},
		connected(val) {
			this.toggleRing(val);
		},
		isLiteUser(val) {
			this.toggleRing(val);
		},
	},
	mounted() {
		if (this.shouldShow) {
			this.toggleRing(true);
		}
	},
	beforeDestroy() {
		this.toggleRing(false);
	},
	methods: {
		setupRing() {
			if (!this.shouldShow || this.ringInterval) {
				return;
			}

			// Ring after 2 seconds.
			this.ringTimeout = setTimeout(() => {
				this.ringing = true;
			}, 2000);

			// Now setup auto-ring every 6 seconds.
			this.ringInterval = setInterval(() => {
				clearTimeout(this.ringTimeout);

				this.ringing = true;

				this.ringTimeout = setTimeout(() => {
					this.ringing = false;
				}, 2000);
			}, 6000);
		},
		endRinging() {
			this.ringing = false;
			clearTimeout(this.ringTimeout);
			clearInterval(this.ringInterval);
		},
		toggleRing(on) {
			if (on && this.shouldShow) {
				this.setupRing();
				document.body.classList.add('omapi-has-alert');
			} else {
				this.endRinging();
				document.body.classList.remove('omapi-has-alert');
			}
		},
	},
};
</script>
<style lang="scss">
@import '../../assets/scss/variables';
.omapi-screen {
	.omapi-alert-bar {
		background: $color_white-button-background;
		padding: 8px 0 9px;
		height: 38px;
		box-sizing: border-box;
		text-align: center;
		line-height: 18px;
		position: relative;
		@media screen and (max-width: 950px) {
			height: 60px;
		}

		a,
		a:hover {
			color: $alert_orange-border !important;
			text-decoration: underline;
			@media screen and (max-width: 950px) {
				display: block;
			}
		}

		&:before {
			content: '';
			background: url('../../assets/images/icons/bell.svg') center center no-repeat;
			display: inline-block;
			width: 15px;
			height: 15px;
			position: relative;
			left: -4px;
			top: 3px;
		}

		&__needs-connection {
			.om-circle-loading {
				display: inline-block;
				margin: 0px 5px -5px;
			}
		}
		&__needs-connection.ringing:before,
		&__needs-upgrade.ringing:before {
			animation: omringbell 4s 0s ease-in-out 1;
			transform-origin: 50% 4px;
		}
	}

	&.omapi-has-alert {
		.omapi-plugin-header {
			padding-top: 38px;
			@media screen and (max-width: 950px) {
				padding-top: 60px;
			}
		}

		.omapi-alert-bar {
			&-wrapper {
				position: absolute;
				top: -112px; // Height of plugin banner (74) + this alert bar (38.
				right: 0;
				width: 100%;
				height: 38px;
				background: $color_white-button-background;
				z-index: 1;
				@media screen and (max-width: 950px) {
					height: 60px;
					top: -134px; // Height of plugin banner (74) + this alert bar (60.
				}
			}
			position: fixed;
			right: 0;
			left: 0;
			margin-left: 160px;
			border: 1px solid #e0e0e0;
			@media screen and (max-width: 960px) {
				margin-left: 36px;
			}
			@media screen and (max-width: 782px) {
				margin-left: 0px;
			}
		}

		&.folded {
			.omapi-alert-bar {
				margin-left: 36px;
			}
		}
	}
}

@keyframes omringbell {
	0% {
		transform: rotate(0);
	}
	1% {
		transform: rotate(30deg);
	}
	3% {
		transform: rotate(-28deg);
	}
	5% {
		transform: rotate(34deg);
	}
	7% {
		transform: rotate(-32deg);
	}
	9% {
		transform: rotate(30deg);
	}
	11% {
		transform: rotate(-28deg);
	}
	13% {
		transform: rotate(26deg);
	}
	15% {
		transform: rotate(-24deg);
	}
	17% {
		transform: rotate(22deg);
	}
	19% {
		transform: rotate(-20deg);
	}
	21% {
		transform: rotate(18deg);
	}
	23% {
		transform: rotate(-16deg);
	}
	25% {
		transform: rotate(14deg);
	}
	27% {
		transform: rotate(-12deg);
	}
	29% {
		transform: rotate(10deg);
	}
	31% {
		transform: rotate(-8deg);
	}
	33% {
		transform: rotate(6deg);
	}
	35% {
		transform: rotate(-4deg);
	}
	37% {
		transform: rotate(2deg);
	}
	39% {
		transform: rotate(-1deg);
	}
	41% {
		transform: rotate(1deg);
	}
	43% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(0);
	}
}
</style>
